import React, { useEffect, useState } from 'react';
import { Form, Input, message, Select, Button } from 'antd';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';

const layout = {
	labelCol: {
		span: 10,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 10,
		span: 16,
	},
};

const UserEditForm = ({ updateUser, fetchUsers, closeModal, user, userLevels, fetchUserLevels }) => {
	const [userType, setUserType] = useState(user?.type);
	const [userLevel, setUserLevel] = useState(user?.userLevel);

	useEffect(() => {
		fetchUserLevels();
	}, []);

	const onFinish = async (values) => {
		await updateUser(user._id, values);
		fetchUsers();
		closeModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<Form
			{...layout}
			name="userForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item
				initialValue={user?.type}
				label="Seller Type"
				name="type"
				rules={InputRules.required('Please select type!')}
			>
				<Select placeholder="Select type" onSelect={(val) => setUserType(val)}>
					<Select.Option value="seller">Seller</Select.Option>
					<Select.Option value="dealer">Dealer</Select.Option>
				</Select>
			</Form.Item>
			<Form.Item label="Level" name={['userLevel']}>
				<Select showSearch allowClear={true} placeholder="Select User Level" mode="level">
					{userLevels
						?.filter((data) => data.levelCategory === userType)
						.map((data, index) => (
							<Select.Option key={index} value={data._id}>
								{data.name}
							</Select.Option>
						))}
				</Select>
			</Form.Item>
			<Form.Item
				initialValue={user?.fullName}
				label="Full Name"
				name="fullName"
				rules={InputRules.required('Please enter name!')}
			>
				<Input placeholder="Enter full name" />
			</Form.Item>
			{userType === 'dealer' && (
				<Form.Item
					initialValue={user?.dealershipName}
					label="Dealership Name"
					name="dealershipName"
					rules={InputRules.required('Please enter dealership name!')}
				>
					<Input placeholder="Enter dealership name" />
				</Form.Item>
			)}
			<Form.Item initialValue={user?.email} label="Email" name="email">
				<Input placeholder="Enter email" />
			</Form.Item>
			<Form.Item initialValue={user?.phone} label="Phone" name="phone">
				<Input placeholder="Enter phone" />
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update User
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({
	userLevels: store.userLevels.userLevels,
});

const mapDispatchToProps = (dispatch) => ({
	fetchUsers: () => dispatch(Actions.fetchUsers()),
	fetchUserLevels: () => dispatch(Actions.fetchAllUserLevels()),
	updateUser: (id, body) => dispatch(Actions.updateUser(id, body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserEditForm);
